import { render } from "./DonationCard.vue?vue&type=template&id=ed0332b8"
import script from "./DonationCard.vue?vue&type=script&lang=js"
export * from "./DonationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__